import { render, staticRenderFns } from "./CalendarDateIcon.vue?vue&type=template&id=51173756"
import script from "./CalendarDateIcon.vue?vue&type=script&lang=ts"
export * from "./CalendarDateIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports